// ============================================================================
// API CONTRACT ENUMS (used in public API query params / response payloads)
// ============================================================================

/** LLM provider identifiers returned by API */
export enum Provider {
  OpenAI = 'openai',
  Anthropic = 'anthropic',
  Google = 'google',
  Perplexity = 'perplexity',
}

export const PROVIDER_VALUES = Object.freeze(Object.values(Provider));
